<ng-container *ngIf="initialized">
    <forge-select #select [formControl]="formControl" [label]="labelText" [required]="isRequired" [invalid]="isInvalid"
                  density="small">

        <forge-circular-progress slot="start" *ngIf="loadingSpinner" diameter="24">
        </forge-circular-progress>

        <ng-container *ngFor="let option of options">
            <forge-option [value]="getValue(option)">
                {{ getDisplayValue(option) }}
            </forge-option>
        </ng-container>

        <span slot="support-text">
            <ng-container *ngIf="showErrorMessage('required')">
                {{label}} is required
            </ng-container>

            <ng-container *ngIf="hasCustomValidators">
                <ng-container *ngFor="let customError of customErrors">
                    <ng-container *ngIf="hasError(customError)">
                        {{customError.message}}
                    </ng-container>
                </ng-container>
            </ng-container>
        </span>
    </forge-select>
</ng-container>